export default __webpack_public_path__ + "static/media/pwaIosSettingsImage.26ad378d.png";